<template> 

  <div class="container pt-4 mb-5">

    <b-button variant="light" :to="('/app/graphic-prompt-creator/')">
      <span class="material-symbols-outlined align-middle">chevron_left</span>
      Wróć
    </b-button>

    <div>
      
      <b-row align-v="center">

        <b-col lg="12">
 
          <div class="mt-4">

            <div class="mt-3">

              <label>Wpisz jaki efekt chcesz osiągnąć za pomocą AI</label>

              <b-input-group>

                <b-form-input v-model="prompt" size="lg" ref="prompt" placeholder="np. kobieta, zamek"></b-form-input>
                
              </b-input-group>

              <b-button variant="outline-secondary mr-1" size="sm" ref="suggest" @click="suggest()" class="mt-3 float-right">
                <span class="material-symbols-outlined align-middle">
                  polyline
                </span>
                Daj sugestie
              </b-button>


              <div v-for="item in suggestData" :key="item.cecha">

                {{ item.cecha }}:

                <span v-for="item2 in item.dane" :key="item2">

                  <b-badge class="ml-2 pointer" @click="addToPrompt(item.cecha + ': ' + item2)">{{ item2 }}</b-badge>

                </span>

              </div>

            </div>

          </div>

        </b-col>

      </b-row>
  
      <hr/>

      <b-row align-v="center" class="mt-2" style="min-height: 40px;">

        <b-col lg="6">
        
        </b-col>

        <b-col lg="6">

        <b-button variant="outline-success mr-1" ref="generatePost" @click="generateFinish()" class="mt-3 float-right">
          <span class="material-symbols-outlined align-middle">
            bolt
          </span>
          Generuj
        </b-button> 

        </b-col>

      </b-row>



      <div class="mt-2" >
  
        <b-card header-tag="header" class="mt-4" v-if="isFinish">

          <template #header>

            <h6 class="mb-0 mt-2 float-left">
              <span v-if="!finishContent"><b-spinner variant='secondary' small></b-spinner> AI generuje treść <small>(może to potrwać dłuższą chwilę. Nie odświeżaj strony!)</small></span>
              <span v-if="finishContent">Wygenerowana treść</span>
            </h6>

            <b-button class="float-right p-0" variant="outline-white" @click="isFinish = false">

              <span class="material-symbols-outlined mt-1">close</span>

            </b-button>

          </template>

          <blockquote class="blockquote mb-0" v-if="result" style="font-size: 1em;">
            
            <div class="mb-3 mt-3 p-3" style="border: 1px dashed #f3f3f3; font-size: 1em; line-height: 1.7em;">

              <div v-if="result" v-html="result" class="pb-3 mb-3" style="border-bottom: 1px solid #ddd;"></div>

            </div>

            <b-button variant="outline-success mr-1" :to="('/app/graphic-nn-ai/')" class="mt-3 float-right">
              <span class="material-symbols-outlined align-middle">
                image
              </span>
              Wygeneruj grafikę
            </b-button>


            <div class="text-primary pointer small mt-1 mr-4 float-left" @click="copyResults">

              <span class="material-symbols-sharp align-middle">content_copy</span>
              Kopiuj do schowka

            </div>

          </blockquote>

        </b-card>
   
        <textarea ref="selectedText" style="display: none;" v-model="selectedText" v-on:focus="$event.target.select()"></textarea>   
        <textarea ref="finishContent" style="display: none;" v-model="finishContent" v-on:focus="$event.target.select()"></textarea>

      </div>
 
    </div>

  </div>

</template>

<script>

  export default {
    name: 'apxc',
    components: {
    },
    data() {
      return {
        isFinish: false,
        result: "",
        result2: "",
        selectedText: '',
        query: "",
        prompt: "",
        finishContent: '',
        suggestData: [],
        selectedSchema: null
      }
    },
    methods: {

      addToPrompt: function(txt) {

        this.prompt = this.prompt + ", " + txt;
      },

      suggest: function() {

        if(!this.prompt) return false;

        this.suggestData = {}

        this.$refs.suggest.disabled = true

        var query = "Robie generator promptow dla grafiki AI, gdzie user wybiera kolejne elementy prompta. Podam Ci rozpoczety juz prompt, a ty daj mi w formacie JSON dalsze mozliwosci kreacji prompta. Pisz w języku polskim. Wynik tylko w czystym formacie JSON, nie dodawaj nic od siebie. Wynik oczekuje jako tablica elementow zawierajacych pola: cecha, dane. Jeśli nie będziesz miał już czego zaproponować - zwróć pustą tablicję w json. Oto dane:" + this.prompt + ".";

        this.axios.post(window.API_URL + "apps/aiPostCreator/getAiText/", { 'text': query, 'v': 'o1' }, { withCredentials: true, timeout: 3000000 }).then((response) => {

          let data = response.data

          if(data.redirectTo) {

            top.location.href = data.redirectTo;

          }

          var tmp = data.result;

          tmp = tmp.replaceAll("```json", '');
          tmp = tmp.replaceAll("```", '');

          this.suggestData = JSON.parse(tmp)

          this.$refs.suggest.disabled = false


        }).catch(function() {

          this.$refs.suggest.disabled = false

        })


      },

      generateFinish: function() {

        if(!this.prompt) return false;

        this.$refs.generatePost.disabled = true

        this.isFinish = true

        this.finishContent = ""
        this.result = ""

        var query = "Stwórz profesjonalne polecenie do sztucznej inteligencji Midjourney żeby stworzyła niezwykłe zdjęcie/grafikę wedlug opisu: " + this.prompt + ".";

        query = query + "Używaj czystego tekstu zamiast markdown. Nie dodawaj komentarza od siebie i nie dodawaj sekcji head. Daj po prostu tekst bez zadnego formatowania.";

        var doneText = "";

        this.axios.post(window.API_URL + "apps/aiPostCreator/getAiText/", { 'text': query, 'v': 'o1' }, { withCredentials: true, timeout: 3000000 }).then((response) => {
  
          let data = response.data
 
          if(data.redirectTo) {

            top.location.href = data.redirectTo;

          }

          doneText = data.result;

          this.finishContent = doneText;

          this.result = doneText.replace(/(?:\r\n|\r|\n)/g, '<br/>');


          this.$refs.generatePost.disabled = false
          this.generatedPostTitle = "Wygenerowana treść"

        }).catch(function() {

          this.$refs.generatePost.disabled = false

         })
 
        
 
      },
 
      copyResults: function() {
 
        this.$refs.finishContent.style.display = "block";
        
        this.$refs.finishContent.focus();

        document.execCommand('copy');
         
        this.$refs.finishContent.style.display = "none"

        window.scrollTo(0, 0)

        this.$bvToast.toast('Treść została skopiowana do schowka', {
          title: 'Skopiowano',
          autoHideDelay: 5000,
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-top-center',
          noCloseButton: true
        })

      } 

    },
    computed: {
  
    },
    created() {

    },
    mounted() {

    },
    watch: {

      finishContent(data) {
        localStorage.graphic_prompt = data;
      }

    }

  }
</script>

<style>

  .pointer { cursor: pointer; }
  .bold { font-weight: 600 !important; }
  code { color: #4e82f7 !important; }
</style>